var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.898 8.02881H21.5761V9.85927H28.898V29.0792H21.5761V30.9096H30.7284V9.85927C30.7284 9.3738 30.5356 8.90822 30.1923 8.56494C29.849 8.22166 29.3834 8.02881 28.898 8.02881Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7207 3.45264H6.12712C5.61252 3.45264 5.119 3.65706 4.75513 4.02094C4.39125 4.38481 4.18683 4.87833 4.18683 5.39293V30.9096H20.661V5.39293C20.661 4.87833 20.4566 4.38481 20.0927 4.02094C19.7288 3.65706 19.2353 3.45264 18.7207 3.45264ZM18.8305 29.0791H16.0848V26.3334H8.76299V29.0791H6.01729V5.39293C6.01729 5.37851 6.02013 5.36423 6.02565 5.3509C6.03117 5.33758 6.03926 5.32547 6.04946 5.31527C6.05966 5.30507 6.07177 5.29698 6.08509 5.29146C6.09842 5.28594 6.1127 5.2831 6.12712 5.2831H18.7207C18.7351 5.2831 18.7494 5.28594 18.7627 5.29146C18.7761 5.29698 18.7882 5.30507 18.7984 5.31527C18.8086 5.32547 18.8167 5.33758 18.8222 5.3509C18.8277 5.36423 18.8305 5.37851 18.8305 5.39293V29.0791Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8476 8.02881H9.67806V9.85927H7.8476V8.02881Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5086 8.02881H13.3391V9.85927H11.5086V8.02881Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1696 8.02881H17.0001V9.85927H15.1696V8.02881Z",
    fill: "#DEDEDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8476 12.6055H9.67806V14.4359H7.8476V12.6055Z",
    fill: "#DEDEDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5086 12.6055H13.3391V14.4359H11.5086V12.6055Z",
    fill: "#DEDEDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1696 12.6055H17.0001V14.4359H15.1696V12.6055Z",
    fill: "#DEDEDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8476 17.1812H9.67806V19.0116H7.8476V17.1812Z",
    fill: "#DEDEDE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5086 17.1812H13.3391V19.0116H11.5086V17.1812Z",
    fill: "#DEDEDE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1696 17.1812H17.0001V19.0116H15.1696V17.1812Z",
    fill: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8476 21.7568H9.67806V23.5873H7.8476V21.7568Z",
    fill: "#DEDEDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5086 21.7568H13.3391V23.5873H11.5086V21.7568Z",
    fill: "#DEDEDE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1696 21.7568H17.0001V23.5873H15.1696V21.7568Z",
    fill: "#DEDEDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5761 12.6055H23.4066V14.4359H21.5761V12.6055Z",
    fill: "#DEDEDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2371 12.6055H27.0675V14.4359H25.2371V12.6055Z",
    fill: "#DEDEDE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5761 17.1812H23.4066V19.0116H21.5761V17.1812Z",
    fill: "#DEDEDE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2371 17.1812H27.0675V19.0116H25.2371V17.1812Z",
    fill: "#DEDEDE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5761 21.7568H23.4066V23.5873H21.5761V21.7568Z",
    fill: "#DEDEDE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2371 21.7568H27.0675V23.5873H25.2371V21.7568Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.faed1b11b2a68ab273e9fa08f4e63d80.svg";
export { ForwardRef as ReactComponent };